import { render, staticRenderFns } from "./MultiCnpjInput.vue?vue&type=template&id=31c1c268&scoped=true&"
import script from "./MultiCnpjInput.vue?vue&type=script&lang=js&"
export * from "./MultiCnpjInput.vue?vue&type=script&lang=js&"
import style0 from "./MultiCnpjInput.vue?vue&type=style&index=0&id=31c1c268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c1c268",
  null
  
)

export default component.exports